
        <MenuItem #reactNode 
            [label]="label" 
            [value]="value" 
            [disabled]="disabled"
            (onClick)="handleOnClick($event)">
        </MenuItem>
    